import { FC } from "react";
import ReactMarkdown from "react-markdown";

const getTextForMarkdown = (text: string) => {
  return text ? text.replaceAll("\n", "\n\n") : "";
};

interface MyMarkdownProps {
  text: string;
}

export const MyMarkdown: FC<MyMarkdownProps> = ({ text }) => {
  return (
    <ReactMarkdown
      children={getTextForMarkdown(text)}
      components={{
        img: ({ node, ...props }) => <img style={{ maxWidth: "100%", width: "500px" }} {...props} />,
        code: ({ node, ...props }) => (
          <code
            style={{
              backgroundColor: "lightgoldenrodyellow",
              padding: "1px 5px",
              borderRadius: "1px",
              fontWeight: 500,
            }}
            {...props}
          />
        ),
        h4: ({ node, ...props }) => <h4 style={{ marginBlockStart: "2em", marginBlockEnd: "0em" }} {...props} />,
        a: ({ node, ...props }) => (
          <a {...props} target="_blank">
            {props.children}
          </a>
        ),
      }}
    />
  );
};
